import { render, staticRenderFns } from "./DiscussionYoung.vue?vue&type=template&id=40e2b499&scoped=true&"
import script from "./DiscussionYoung.vue?vue&type=script&lang=js&"
export * from "./DiscussionYoung.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionYoung.vue?vue&type=style&index=0&id=40e2b499&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e2b499",
  null
  
)

export default component.exports